import { createRouter, createWebHistory } from 'vue-router';
import LoginBox from '../components/login/LoginBox.vue';
import FairList from '../components/fairs/EventsList.vue';
import EventsDates from '../components/fairs/EventsDates.vue';
import EventsListByDay from '../components/events/EventsListByDay.vue';
import EventsList from '../components/events/EventsList.vue';
import PageLayout from '../components/menu/PageLayout.vue';
import ContactPage from '../components/contacts/ContactPage.vue';
import ProfilePage from '../components/contacts/ProfilePage.vue';
import CalendarRoom from '../components/bookings/CalendarRoom.vue';
import CalendarDay from '../components/bookings/CalendarDay.vue';
import NotFound from '../components/NotFound.vue';

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: "/events/:id",
      component: PageLayout,
      props: true,
      beforeEnter: (to, from, next) => {
        const id = to.params.id;
        if (isNaN(id)) next('/not-found');
          else next();
      }
    },
    {
      path: "/events/:id/presence",
      component: EventsDates,
      props: true
    },
    {
      path: "/events/:id/rooms/booking/day-:dayid",
      component: CalendarDay,
      props: true
    },
    {
      path: "/events/:id/rooms/booking/day-:dayid/room-:roomid",
      component: CalendarRoom,
      props: true
    },
    {
      path: "/events/:id/events/daybyday",
      component: EventsListByDay,
      props: true
    },
    {
      path: "/events/:id/events/:type/day-:dayid",
      component: EventsList,
      props: true
    },
    {
      path: "/events/:id/events/:type",
      component: EventsList,
      props: true
    },
    {
      path: "/events/:id/:page",
      component: PageLayout,
      props: true
    },
    {
      path: "/events/:id/:page/:subpage",
      component: PageLayout,
      props: true
    },
    {
      path: "/events/:id/:page/:subpage/:endpage",
      component: PageLayout,
      props: true
    },
    {
      path: "/events/:id/:page/:subpage/contact-:contactid",
      component: ContactPage,
      props: true
    },
    {
      path: "/events",
      component: FairList,
    },
    {
      path: "/profile/:action",
      component: ProfilePage,
      props: true
    },
    {
      path: "/profile",
      component: ProfilePage
    },
    {
      path: "/login",
      component: LoginBox,
    },
    {
      path: "/",
      component: LoginBox,
    },
    {
      path: '/:pathMatch(.*)*',
      component: NotFound
    }
  ],
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  //const offline = localStorage.getItem("offline");
  if (!token) {
    if (to.path !== '/') next("/");
    else next();
  } else {
    /*if (offline) {
      if (to.path === '/') next("/events");
      else next();
      return false;
    }*/
		next();
  }
});

export default router;